import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import FormControl from 'react-bootstrap/FormControl';
import Row from 'react-bootstrap/Row';
import { toast } from 'react-toastify';
import useAxios from '../hooks/useAxios';
import { getError } from '../utils';

export default function SearchProduct(props) {
  const axios = useAxios();
  const { addHandler, userInfo, type, showFeatures } = props;

  const [query, setQuery] = useState(props.query ? props.query : '');
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          `/api/products/admin/search?page=1&query=${query}&type=${type}&pageSize=3`
        );
        setProducts(data.products);
      } catch (err) {
        toast.error(getError(err));
      }
    };

    fetchData();
  }, [userInfo, query]);

  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th>
              <FormControl
                type="text"
                name="q"
                id="q"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Ürün ara..."
                aria-label="Ürün ara"
                aria-describedby="button-search"
              ></FormControl>
            </th>
          </tr>
        </thead>
        <tbody>
          {products.map((product) =>
            showFeatures && product.features && product.features.length > 0 ? (
              product.features.map((f) => (
                <tr key={product._id + '' + f.name}>
                  <td>
                    <Row>
                      <Col md={9}>
                        <div>{f.name + ' ' + product.name}</div>
                      </Col>
                      <Col md={3} className="col text-end">
                        <Button
                          className="textDecorationNone"
                          variant="light"
                          onClick={() => addHandler(product, f.name)}
                        >
                          <i className="fas fa-plus"></i>
                        </Button>
                      </Col>
                    </Row>
                  </td>
                </tr>
              ))
            ) : (
              <tr key={product._id}>
                <td>
                  <Row>
                    <Col md={6}>
                      <div>{product.name}</div>
                    </Col>
                    <Col md={6} className="col text-end">
                      <Button
                        className="textDecorationNone"
                        variant="light"
                        onClick={() => addHandler(product)}
                      >
                        <i className="fas fa-plus"></i>
                      </Button>
                    </Col>
                  </Row>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
}
